import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/i18n";

export const AuthModal = ({ 
  open, 
  onOpenChange, 
  authMode, 
  setAuthMode,
  onSubmit,
  authForm,
  setAuthForm
}) => {
  const { t } = useLanguage();
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-900 border-zinc-800">
        <DialogHeader>
          <DialogTitle className="text-white">
            {authMode === "login" ? t('login') : authMode === "register" ? t('register') : t('change_password')}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          {authMode === "register" && (
            <Input 
              placeholder={t('name')} 
              value={authForm.name} 
              onChange={(e) => setAuthForm({...authForm, name: e.target.value})} 
              className="bg-zinc-800 border-zinc-700" 
              required 
              data-testid="auth-name" 
            />
          )}
          {authMode !== "password" && (
            <Input 
              type="email" 
              placeholder={t('email')} 
              value={authForm.email} 
              onChange={(e) => setAuthForm({...authForm, email: e.target.value})} 
              className="bg-zinc-800 border-zinc-700" 
              required 
              data-testid="auth-email" 
            />
          )}
          <div className="relative">
            <Input 
              type={showPassword ? "text" : "password"} 
              placeholder={authMode === "password" ? t('current_password') : t('password')} 
              value={authForm.password} 
              onChange={(e) => setAuthForm({...authForm, password: e.target.value})} 
              className="bg-zinc-800 border-zinc-700 pr-10" 
              required 
              data-testid="auth-password"
            />
            <button 
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-white"
              data-testid="toggle-password"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
          {authMode === "password" && (
            <div className="relative">
              <Input 
                type={showPassword ? "text" : "password"} 
                placeholder={t('new_password')} 
                value={authForm.newPassword} 
                onChange={(e) => setAuthForm({...authForm, newPassword: e.target.value})} 
                className="bg-zinc-800 border-zinc-700 pr-10" 
                required 
              />
            </div>
          )}
          <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700" data-testid="auth-submit">
            {authMode === "login" ? t('login') : authMode === "register" ? t('register') : t('change_password')}
          </Button>
          {authMode !== "password" && (
            <p className="text-center text-zinc-500 text-sm">
              {authMode === "login" ? (
                <>{t('dont_have_account')} <button type="button" className="text-blue-500 hover:underline" onClick={() => setAuthMode("register")}>{t('register')}</button></>
              ) : (
                <>{t('already_have_account')} <button type="button" className="text-blue-500 hover:underline" onClick={() => setAuthMode("login")}>{t('login')}</button></>
              )}
            </p>
          )}
        </form>
      </DialogContent>
    </Dialog>
  );
};
